export type PreviewDevice = 'desktop' | 'tablet' | 'mobile';

export type PreviewDeviceFrameStyle = {
  readonly maxWidth: string;
};

export const PREVIEW_DEVICES: readonly PreviewDevice[] = ['desktop', 'tablet', 'mobile'] as const;

/** Viewport widths used to constrain the preview iframe (CSS media queries react to these). */
export const PREVIEW_DEVICE_WIDTH_PX: Readonly<Record<PreviewDevice, number | undefined>> = {
  desktop: undefined,
  tablet: 768,
  mobile: 390,
};

export function isPreviewDevice(value: unknown): value is PreviewDevice {
  return value === 'desktop' || value === 'tablet' || value === 'mobile';
}

export function previewDeviceFrameClassName(device: PreviewDevice): string {
  return `studio-preview-frame is-${device}`;
}

export function previewDeviceFrameStyle(
  device: PreviewDevice
): PreviewDeviceFrameStyle | undefined {
  const widthPx = PREVIEW_DEVICE_WIDTH_PX[device];
  if (widthPx === undefined) {
    return undefined;
  }
  return { maxWidth: `${String(widthPx)}px` };
}
